import {Component} from '@angular/core';
import {ModalController} from '@ionic/angular';

@Component({
  selector: 'app-why-intro-read-more',
  template: `
    <ion-content scroll-y="false" class="pd-lr-16 intro-page">
      <div class="header-ht">
        <ion-buttons slot="end" class="pd-top-50">
          <ion-button (click)="dismiss()" class="close_btn">
            <ion-icon slot="icon-only" class="add__color primary-shade" name="close"></ion-icon>
          </ion-button>
        </ion-buttons>
      </div>
      <div class="read-more-wrapper">
        <div class="d-flex justify-content-start pd-top-24">
          <img class="mapimo-logo read-more" src="assets/img/logo/LOGO-MAPIMO.svg"/>
        </div>
        <div class="pd-top-40">
          <ion-label class="input-text-label p2 dark">{{"intro.desc1" | translate}}</ion-label>
        </div>
        <div class="pd-top-20">
          <ion-label class="input-text-label p2 dark">{{"intro.desc2" | translate}}</ion-label>
        </div>
        <div class="pd-top-20">
          <ion-label class="input-text-label p2 dark">{{"intro.desc3" | translate}}</ion-label>
        </div>
      </div>
    </ion-content>
  `,
  styleUrls: ['./intro.component.scss']
})
export class IntroReadMoreComponent {
  constructor(public modalCtrl: ModalController) {
  }

  dismiss() {
    this.modalCtrl.dismiss();
  }

}
